<template>
  <div class="container mb-5">
    <ol class="breadcrumb arr-right mb-0 mb-md-3 mt-4">
      <li class="breadcrumb-item">
        <div class="headings">{{ $t('holidays.index.title') }}</div>
      </li>
      <li class="breadcrumb-item reference-heading">
        {{ $t('menu.masterBL') }}
      </li>
    </ol>
    <div id="result-found">
      <div class="position-relative" id="image-section">
        <img
          src="@/assets/images/common/master-bl-banner.png"
          alt="Master BL Banner Image"
          class="banner-image"
        />
        <div class="search-line-container">
          <div class="title-slash">
            {{ $t('masterBl.searchLine') }}
          </div>
        </div>
        <div class="input-container">
          <b-icon-search class="search-icon" font-scale="0.9" />
          <input
            class="input-box"
            v-model="searchedInput"
            :placeholder="$t('masterBl.inputPlaceholder')"
            @input="$event.target.composing = false"
          />
        </div>
      </div>
      <div class="main-section" id="body">
        <div class="sort-section">
          <p class="sort-text">{{ $t('masterBl.sortBy.heading') }}</p>
          <div
            @click="sequenceHandler('atoz')"
            :class="{ greenSeq: activeSequence === 'atoz' }"
            class="seq"
          >
            {{ $t('masterBl.sortBy.atoz') }}
          </div>
          <div
            @click="sequenceHandler('ztoa')"
            :class="{ greenSeq: activeSequence === 'ztoa' }"
            class="seq"
          >
            {{ $t('masterBl.sortBy.ztoa') }}
          </div>
        </div>
        <div class="heading">
          {{ $t('masterBl.heading') }}
        </div>
        <div id="master-bl-data" v-if="isSearchedResult">
          <div v-for="(value, key) in filterList" :key="key">
            <!-- this if condition check whether array has some value or not, If there is no value no need to render that alphabet -->
            <!-- alphabet rendering -->
            <div class="bl-list-heading">{{ key }}</div>
            <div class="bl-list-container">
              <div v-for="item in value" :key="item" class="bl-value">
                <img
                  src="@/assets/images/common/master-bl-ship.svg"
                  :alt="item"
                  class="bl-value-ship"
                />
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="sorry-container">
          <div class="heading">
            {{ $t('masterBl.sorry.heading') }}
            <span class="font-weight-bold">"{{ searchedInput }}"</span>
          </div>
          <img
            src="@/assets/images/common/master-bl-no-result.svg"
            alt="Sorry Image"
            class="sorry-image"
          />
          <div class="mt-4">{{ $t('masterBl.sorry.line1') }}</div>
          <div>
            {{ $t('masterBl.sorry.line2') }}
            <a href="mailto:dripassist@dripcapital.com">{{
              $t('masterBl.sorry.email')
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import isEmpty from 'lodash/isEmpty'
import platformService from '@/services/platform'

export default {
  data() {
    return {
      activeSequence: 'atoz',
      masterBLJson: [],
      searchedInput: ''
    }
  },
  methods: {
    sequenceHandler(value) {
      this.$mpTrack(`Master BL list - Sort by ${value}`)
      this.activeSequence = value
      this.searchedInput = ''
    },
    formatData(json) {
      const renderingObj = {}
      const alphabet = this.getArrayString() // This will give array ['A','B'.....'Z']
      const revesedAlphabet = [...alphabet].reverse()
      /**
      REQUIREMENT:-
      Now we need to format this data in this form
       {
        "A": [
          "ACL",
        ],
        "B": [
          "BLPL",
        ]
      }
      STEPS:-
      1. Making a object {A:[],B:[]}
      2. Pushing the value in object key('A') array and try catch for any error handling,
         there may be a posibility of getting a key that is not in object key
      3. Delete the Empty keys from object
      4. Returning that formated object
     **/
      let activeSeq = this.activeSequence
        ? this.activeSequence === 'atoz'
        : true
      if (activeSeq) {
        alphabet.forEach((el) => {
          renderingObj[el] = []
        })
      } else {
        revesedAlphabet.forEach((el) => {
          renderingObj[el] = []
        })
      }
      json.forEach((blValue) => {
        try {
          renderingObj[blValue[0].toUpperCase()].push(blValue)
        } catch (e) {
          console.log(e)
        }
      })
      for (const property in renderingObj) {
        if (renderingObj[property].length === 0) {
          delete renderingObj[property]
        }
      }
      return renderingObj
    },
    getArrayString() {
      const alpha = Array.from(Array(26)).map((e, i) => i + 65)
      const alphabet = alpha.map((x) => String.fromCharCode(x))
      return alphabet
    },
    fetchMasterBlList() {
      return platformService.fetchShippingLines().then((res) => {
        if (res.data) {
          this.masterBLJson = res.data.map((el) => el.name).sort()
        }
      })
    }
  },
  mounted() {
    this.fetchMasterBlList()
  },
  computed: {
    isSearchedResult() {
      return !isEmpty(this.filterList)
    },
    filterList() {
      const filteredList = this.masterBLJson.filter((item) =>
        item.toUpperCase().includes(this.searchedInput.toUpperCase())
      )
      return this.formatData(filteredList)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.banner-image {
  width: 100%;
}
.input-container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  width: 90%;
}
.search-line-container {
  position: absolute;
  bottom: 15%;
  color: $white;
  text-transform: uppercase;
  left: 5%;
  font-size: 1.2rem;
}
.input-box {
  width: 100%;
  padding: 0.6rem;
  border-radius: 0.5rem;
  border: none;
  box-shadow: $box-shadow-sm;
  outline: none;
  padding-left: 3rem;
}
.search-icon {
  position: absolute;
  font-size: 1.5rem;
  color: $grey-text;
  top: 50%;
  left: 1rem;
  transform: translateY(-60%);
}
.main-section {
  width: 90%;
  margin: 0 auto;
  .sort-section {
    display: flex;
    margin-top: 3rem;
    align-items: center;
    .seq {
      background-color: $background-light;
      border-radius: 20px;
      margin-left: 1rem;
      padding: 0.4rem 1.5rem;
      cursor: pointer;
      color: $grey-text;
    }
    .greenSeq {
      background-color: $approved-color;
      color: $white;
    }
    .sort-text {
      color: $grey-text;
      margin: 10px 0;
    }
  }
  .heading {
    color: $approved-color;
    margin: 1.5rem 0;
    font-size: 1.4rem;
  }
  .bl-list-heading {
    font-size: 2.5rem;
    color: $grey-text;
    margin: 2rem 0 0.5rem;
  }

  .bl-list-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: -2.5rem;
    .bl-value {
      background-color: $white;
      margin-right: 1.5rem;
      padding: 1rem 1.5rem;
      border-radius: 0.4rem;
      margin-top: 2.5rem;
    }
    .bl-value-ship {
      margin-right: 0.8rem;
    }
  }
}
.sorry-container {
  margin: 4rem auto;
  text-align: center;
  .heading {
    font-size: 1.5rem;
    color: $grey-text;
  }
  a {
    display: inline-block;
  }
}
@include media-breakpoint-down(sm) {
  .container {
    padding: 0rem !important;
  }
  .search-line-container {
    bottom: 25%;
    font-size: 1rem;
  }
  .banner-image {
    width: 100%;
    height: 100px;
  }
  .main-section {
    width: 90%;
    margin: 0 auto;
    .heading {
      font-size: 1rem;
      margin: 1rem 0;
    }
    .bl-list-container {
      display: flex;
      flex-wrap: wrap;
      margin-top: -2rem;
      .bl-value {
        background-color: $white;
        margin-right: 1rem;
        padding: 0.5rem 1rem;
        border-radius: 0.4rem;
        margin-top: 2rem;
      }
      .bl-value-ship {
        margin-right: 0.4rem;
      }
    }
  }
  .sorry-container {
    margin: 2rem auto;
    .sorry-image {
      width: 100%;
    }
  }
}
</style>
